import axios from 'axios';
import { useEffect, useState } from 'react';

function useFetchLocale() {
  const [countryCode, setCountryCode] = useState(undefined);
  const [ip, setIp] = useState(undefined);

  useEffect(() => {
    (async () => {
      const { data } = await axios({
        method: 'GET',
        withCredentials: true,
        url:
          process.env.NODE_ENV === 'production'
            ? 'https://cfproductionapi.alitu.com/locale'
            : 'https://cfstagingapi.alitu.com/locale',
      });
      setIp(data.ip);
      setCountryCode(data.country);
    })();
  }, [setIp, setCountryCode]);

  return { ip, countryCode };
}

export default useFetchLocale;
